import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import QRCode from 'qrcode.react';
import queryString from 'query-string';
import { totpSelector, mfaErrorsSelector } from 'store/selectors';
import { TOTPVerifyCode } from 'actions/mfa';
import { POSTERGACION_2FA_LOGIN } from 'constants/RouterConstants';
import Card from 'components/Card';
import ButtonSolid from 'components/ButtonSolid';
import Snackbar from 'components/Snackbar';

import './configurarAplicativo.css';
import '../totp_configurar_app/totpCard.css';
import { DEFAULT_SNACKBAR_INFO } from 'constants/commonConstants';

const ConfigurarAplicativo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const totp = useSelector(totpSelector);
  const mfaErrors = useSelector(mfaErrorsSelector);
  const [codigo, setCodigo] = useState();
  const [isLogin, setIsLogin] = useState(false);
  const [snackBarInfo, setSnackBarInfo] = useState(DEFAULT_SNACKBAR_INFO);
  useEffect(() => {
    const { login } = queryString.parse(history.location.search);
    if (login) setIsLogin(true);
    history.replace(history.location.pathname);
  }, [history]);
  const TITULO =
    'Para configurar el doble factor con un aplicativo de autenticación, seguí estos pasos:';
  return (
    <Card title={TITULO}>
      <span>
        1) Desde la tienda oficial (Google Play o App Store), descargá e instalá
        en tu celular una aplicación de autenticación como Google Authenticator,
        Microsoft Authenticator o cualquiera compatible con TOTP.
      </span>
      <br />
      <span>
        {`2) Abrí la aplicación, agregá una nueva cuenta generalmente con el boton
        "+" y escaneá el siguiente código QR o ingresá manualmente el código.`}
      </span>
      <br />
      <div className="totp-card-fill">
        <div className="totp-card-section totp-card-section--qr-code">
          <QRCode
            className="totp-card__qr"
            value={totp?.url}
            renderAs="svg"
            size={128}
            level="Q"
          />
        </div>
        <div className="totp-card-section totp-card-section--text">
          <div className="totp-card-section__code">
            {totp?.secret}
            <div className="boton-copiar">
              <ButtonSolid
                text="Copiar"
                handleClick={() => {
                  navigator.clipboard.writeText(totp?.secret);
                  setSnackBarInfo({
                    mostrar: true,
                    texto: 'Código copiado al portapapeles',
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <br />
      <span>
        3) Ingresá el código que indica la aplicación de autenticación:
      </span>
      <input
        className="input-demo"
        type="text"
        onChange={e => setCodigo(e.target.value)}
        value={codigo}
        aria-label="Código de verificación"
      />
      {mfaErrors && (
        <span style={{ fontSize: '15px', color: '#B60000' }}>{mfaErrors}</span>
      )}
      <div className="button-container">
        <ButtonSolid
          text="Confirmar"
          handleClick={() =>
            dispatch(TOTPVerifyCode(totp?.id, codigo, isLogin))
          }
          style={{ marginTop: '20px' }}
        />
        {isLogin && (
          <button
            type="button"
            onClick={() => history.push(POSTERGACION_2FA_LOGIN)}
            style={{
              lineHeight: '24px',
              textDecorationLine: 'underline',
              color: 'blue',
              padding: '8px 24px',
            }}
          >
            Configurar más tarde
          </button>
        )}
      </div>
      <Snackbar
        desplegar={snackBarInfo.mostrar}
        mensaje={snackBarInfo.texto}
        onClose={() => setSnackBarInfo(DEFAULT_SNACKBAR_INFO)}
      />
    </Card>
  );
};

export default ConfigurarAplicativo;
